import { render, staticRenderFns } from "./Attendances.vue?vue&type=template&id=0e964728"
import script from "./Attendances.vue?vue&type=script&lang=js"
export * from "./Attendances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports